/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Dash_Desc4Inputs */

const en_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typed, schema-validated model responses, not free-form JSON you have to trust, wired straight into your backend.`)
};

const ar_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ردود نموذج مكتوبة ومتحقق منها بمخططات، لا JSON حرة تثق بها، مدمجة مباشرة في الـ backend.`)
};

const bn_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টাইপড, স্কিমা-ভ্যালিডেটেড মডেল রেসপন্স, বিশ্বাস করতে হবে এমন ফ্রি-ফর্ম JSON নয়, সরাসরি আপনার ব্যাকএন্ডে।`)
};

const de_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typisierte, schemavalidierte Modellantworten, kein Freiform-JSON, dem Sie vertrauen müssen, direkt in Ihr Backend integriert.`)
};

const es_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas tipadas y validadas por esquema, no JSON libre en el que deba confiar, conectadas a su backend.`)
};

const fr_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses de modèle typées et validées par schéma, pas du JSON libre auquel vous devez faire confiance, branchées directement dans votre backend.`)
};

const pt_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas tipadas e validadas por esquema, não JSON livre em que você precisa confiar, conectadas diretamente ao seu back-end.`)
};

const zh_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型化、模式验证的模型响应，而不是您必须信任的自由格式 JSON，直接连接到您的后端。`)
};

const tr_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılı, şema tarafından doğrulanmış model yanıtları, güvenmeniz gereken serbest biçimli JSON değil, doğrudan arka ucunuza bağlanır.`)
};

const ru_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Типизированные, валидированные по схеме ответы модели, а не free-form JSON, которому надо верить,, прямо в ваш бэкенд.`)
};

const pl_svc_ai_integration_dash_desc4 = /** @type {(inputs: Svc_Ai_Integration_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typowane, schematowo zwalidowane odpowiedzi modelu, nie swobodny JSON, w który musisz wierzyć, wpięte prosto w twój backend.`)
};

/**
* | output |
* | --- |
* | "Typed, schema-validated model responses, not free-form JSON you have to trust, wired straight into your backend." |
*
* @param {Svc_Ai_Integration_Dash_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_dash_desc4 = /** @type {((inputs?: Svc_Ai_Integration_Dash_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Dash_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_dash_desc4(inputs)
	if (locale === "bn") return bn_svc_ai_integration_dash_desc4(inputs)
	if (locale === "de") return de_svc_ai_integration_dash_desc4(inputs)
	if (locale === "es") return es_svc_ai_integration_dash_desc4(inputs)
	if (locale === "fr") return fr_svc_ai_integration_dash_desc4(inputs)
	if (locale === "pt") return pt_svc_ai_integration_dash_desc4(inputs)
	if (locale === "zh") return zh_svc_ai_integration_dash_desc4(inputs)
	if (locale === "tr") return tr_svc_ai_integration_dash_desc4(inputs)
	if (locale === "ru") return ru_svc_ai_integration_dash_desc4(inputs)
	if (locale === "pl") return pl_svc_ai_integration_dash_desc4(inputs)
	return en_svc_ai_integration_dash_desc4(inputs)
});
export { svc_ai_integration_dash_desc4 as "svc_ai-integration_DASH_desc" }